// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad586e84","455":"fe1eaff0"}[chunkId] + ".chunk.js";
};